import React from "react";

import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";

import { faMessage } from "@fortawesome/free-solid-svg-icons/faMessage"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { enviarEmail } from "../../../utils/enviarEmail";
import { Formulario } from "../../form";
import { useTranslation } from "react-i18next";

import "../../../utils/font-roboto.scss";
import "./index.scss";

const Contato = () => {
    const { t } = useTranslation();


   const EnviarMensagemWhatsApp = ({ children }) => {
    const whatsappNumber = "5527996676885";
    const message = encodeURIComponent(
      "Olá, gostaria de mais informações sobre seus serviços!"
    );
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;
    return (
      <a
        style={{ width: "100%", textDecoration:"none" }}
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        title="Converse conosco pelo WhatsApp!"
      >
        {children}
      </a>
    );
  };
  return (
    <div className="pagina-contato">
      <div className="contato">
        <div className="px32">{t('contato.texto')}</div>
        <div className="caixa-formulario">
          <Formulario
            nomeCampo
            emailCampo
            empresaCampo
            telefoneCampo
            mensagemCampo
            formularioTransparente
            apiEnvio=""
            textoBotao={t('contato.botao')}
          />
        </div>
      </div>
      <div style={{ display:"flex", flexDirection:"column", gap:"25px"}}>
      <div className="email" onClick={() => enviarEmail()}>
        <FontAwesomeIcon icon={faEnvelope} className="icone" style={{maxWidth:"40%", width:"50px"}} />
        <div className="texto px20">{t('contato.email')}</div>
      </div>
      <EnviarMensagemWhatsApp>
      <div className="email" style={{width:"100%"}}>
        <FontAwesomeIcon icon={faMessage} className="icone" style={{maxWidth:"40%",width:"50px" }} />
        <div className="texto px20">WhatsApp</div>
      </div>
      </EnviarMensagemWhatsApp>
      </div>
      
    </div>
  );
};

export default Contato;
